import React from "react";
import styled from "styled-components";

const HeroSection = () => {
  return (
    <Section>
      <h1>Hi, my name is</h1>
      <h2>Tushar Ahmmed.</h2>
      <h3>I build things for the web.</h3>
      <p>
        I’m a frontend developer specializing in building web applications
        frontend. Currently, I’m focused on building accessible, human-centered
        products at <span>Air Cyurs</span>.
      </p>
      <a href="https://www.github.com/tusharahmmed" target="_blank">
        <EmailBtn className="email-btn">Check out my github!</EmailBtn>
      </a>
    </Section>
  );
};

export default HeroSection;

// styled components

const Section = styled.section`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  min-height: 100vh;
  margin: auto;
  max-width: 1000px;

  h1 {
    margin: 6px 0px 20px 4px;
    color: var(--green);
    font-family: ${(props) => props.theme.fonts.sf};
    font-size: clamp(var(--fz-sm), 5vw, var(--fz-md));
    font-weight: 400;
  }
  h2 {
    margin: 0px;
    font-size: clamp(40px, 8vw, 80px);
    font-family: ${(props) => props.theme.fonts.calibre_b};
    line-height: 0.9;
  }
  h3 {
    margin-top: 5px;
    color: var(--slate);
    line-height: 0.9;
    font-size: clamp(40px, 8vw, 80px);
    font-family: ${(props) => props.theme.fonts.calibre_b};
  }
  p {
    margin: 20px 0px 0px;
    max-width: 540px;
    color: var(--slate);
    font-size: var(--fz-xl);
    font-family: ${(props) => props.theme.fonts.calibre_r};
    line-height: 1.3;
    font-weight: 400;

    span {
      color: var(--green);
    }
  }
`;

const EmailBtn = styled.button`
  font-family: ${(props) => props.theme.fonts.sf};
`;
